const Login = {
    namespaced: true,
    getters: {},
    state: {
        LoginData:null,
    },
    mutations: {
        LOGINDATA(state, data){
            state.LoginData = data
        },

    },
    actions: {

    },
}
export default Login